/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:0a678f41-9eed-4b97-b7c1-699d4bcde4ed",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_0HIjmJ8V5",
    "aws_user_pools_web_client_id": "5a1ucee1rhndd1ktghvntshth4",
    "oauth": {},
    "aws_user_files_s3_bucket": "rims4fd84d1e67f84e93b77dc152018e457e213043-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_content_delivery_bucket": "rims-20210220220202-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "http://rims-20210220220202-hostingbucket-prod.s3-website-eu-west-1.amazonaws.com",
    "aws_appsync_graphqlEndpoint": "https://lfoi5ke375dafhxij2rb7oonrm.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
